import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Force a repaint of the whole UI when theme changes
  useEffect(() => {
    // This is a hacky way to force a repaint of CSS variables in some browsers
    document.body.style.display = 'none';
    // Force a reflow
    void document.body.offsetHeight;
    document.body.style.display = '';
    
    // Additional fix: add theme classes to html, body, and specific elements
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
      document.body.classList.add('dark');
      document.body.classList.remove('light');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
      document.body.classList.add('light');
      document.body.classList.remove('dark');
    }
    
    // Update CSS variables
    document.documentElement.style.setProperty('--current-theme', theme);
  }, [theme]);

  const handleToggle = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      toggleTheme();
      setTimeout(() => {
        setIsTransitioning(false);
      }, 300); // Match the CSS transition duration
    }, 10);
  };

  return (
    <button
      onClick={handleToggle}
      className={`notification-button ${isTransitioning ? 'theme-icon-transition' : ''}`}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      disabled={isTransitioning}
    >
      {theme === 'dark' ? (
        <Sun size={20} className={`text-white ${isTransitioning ? 'animate-spin-slow' : ''}`} />
      ) : (
        <Moon size={20} className={`text-gray-800 ${isTransitioning ? 'animate-spin-slow' : ''}`} />
      )}
    </button>
  );
}